import { TxStatusObj } from 'modules/blockChain/types'

export type NFCSStatus =
  | 'loading'
  | 'not-generated'
  | 'generating'
  | 'generated'
  | 'failed'
  | 'rate-limit'
  | 'server-error'

export type NFCSFormSings = Record<string, string | null | undefined>

export enum NFCSFormStep {
  Start = 0,
  Intermediate = 1,
  Finish = 2,
}

export type NFCSFormState = {
  signs: NFCSFormSings
  setSigns: (state: Partial<NFCSFormSings>) => void
  currentFormStep: NFCSFormStep
  handleCurrentFormStepChange: (step: NFCSFormStep) => void
  signedAddresses: string[]
}

export type NFCSInfo = {
  tokenId: number | null | undefined
  notStarted?: boolean
  primaryBundleAddress: string | null | undefined
  isPrimaryAddress: boolean | null | undefined
  nfcs: number
  nfcsBundle: string[]
}

export type NFCSTxState = {
  txHash: string | null | undefined
  txStatus: TxStatusObj
  setTxHash: (txHash: string | null) => void
  resetTx: () => void
}
